import * as React from "react";
import { BaseIcon, BaseIconProps } from "@/components/icons/primitives/BaseIcon";

/**
 * Discord logo icon - simple logo mark without background
 * Use this for custom styling with your own underlay
 *
 * @example
 * ```tsx
 * // With default underlay
 * <DiscordIcon size="md" withUnderlay />
 *
 * // With custom underlay
 * <DiscordIcon
 *   size="md"
 *   withUnderlay
 *   underlayClassName="size-10 bg-custom"
 * />
 * ```
 */
export const DiscordIcon = React.forwardRef<SVGSVGElement, Omit<BaseIconProps, "children">>((props, ref) => {
  return (
    <BaseIcon ref={ref} aria-label="Discord" viewBox="0 0 20 15" {...props}>
      <path
        d="M16.6577 1.2432C15.4031 0.667482 14.0589 0.243572 12.6525 0.00106511C12.6267 -0.00370864 12.6009 0.00775489 12.5885 0.0316237C12.4157 0.339053 12.2238 0.741002 12.0901 1.05607C10.5778 0.829793 9.07314 0.829793 7.59137 1.05607C7.45675 0.733364 7.25816 0.339053 7.08439 0.0316237C7.07103 0.00870964 7.04525 -0.00275389 7.02043 0.00106511C5.61504 0.243572 4.2698 0.667482 3.01526 1.2432C3.00475 1.24797 2.9952 1.25561 2.98852 1.26611C0.437427 5.07747 -0.26147 8.79528 0.081286 12.4673C0.0831955 12.4854 0.0927448 12.5026 0.107066 12.5131C1.79029 13.7495 3.42103 14.4999 5.02119 14.9973C5.04697 15.005 5.0737 14.9954 5.08993 14.9744C5.46801 14.4579 5.80599 13.9127 6.09528 13.3389C6.11247 13.3055 6.09527 13.2654 6.0609 13.2521C5.52529 13.0487 5.0164 12.8014 4.52566 12.5207C4.48651 12.4978 4.48366 12.4424 4.51899 12.4157C4.6221 12.3384 4.72521 12.2582 4.82355 12.177C4.84169 12.1617 4.8665 12.1589 4.88751 12.1684C8.10788 13.6387 11.5946 13.6387 14.7768 12.1684C14.7978 12.1579 14.8226 12.1617 14.8408 12.176C14.9391 12.2572 15.0422 12.3384 15.1463 12.4157C15.1816 12.4424 15.1797 12.4978 15.1406 12.5207C14.6508 12.8071 14.141 13.0496 13.6044 13.2521C13.5691 13.2654 13.5538 13.3055 13.571 13.3399C13.8669 13.9127 14.204 14.457 14.5754 14.9744C14.5906 14.9964 14.6183 15.0059 14.6441 14.9983C16.2519 14.5009 17.8826 13.7504 19.5658 12.514C19.5802 12.5035 19.5897 12.4863 19.5916 12.4692C20.0022 8.22434 18.9042 4.53709 16.6825 1.26802C16.6768 1.25752 16.6682 1.24893 16.6567 1.24415L16.6577 1.2432ZM6.57455 10.2312C5.60452 10.2312 4.80637 9.34139 4.80637 8.2482C4.80637 7.15501 5.5902 6.26519 6.57455 6.26519C7.55889 6.26519 8.35898 7.16361 8.34275 8.2482C8.34275 9.34139 7.55889 10.2312 6.57455 10.2312ZM13.1136 10.2312C12.1436 10.2312 11.3455 9.34139 11.3455 8.2482C11.3455 7.15501 12.1293 6.26519 13.1136 6.26519C14.098 6.26519 14.8981 7.16361 14.8818 8.2482C14.8818 9.34139 14.1066 10.2312 13.1136 10.2312Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
});

DiscordIcon.displayName = "DiscordIcon";
